<template>
  <div>
    <vs-tabs class="cstm-card">
      <vs-tab label="Lesson">
        <overall-content @get_all_content="getContent" :platform_customer_id="customer_id" />
      </vs-tab>

      <vs-tab label="Homework">
        <template v-for="(homework, subject) in classHomework">
          <vs-collapse :key="subject" class="cstm-card">
            <vs-collapse-item>
              <div slot="header">{{ subject }}</div>

              <class-assignment-modal
                :lessonAssignment="homework"
                :sectionType="1"
                :class_id="class_id"
                :platform_customer_id="customer_id"
              ></class-assignment-modal>
            </vs-collapse-item>
          </vs-collapse>
        </template>
      </vs-tab>

      <vs-tab label="Exam">
        <template v-for="(exam, subject) in classExam">
          <vs-collapse :key="subject" class="cstm-card">
            <vs-collapse-item>
              <div slot="header">{{ subject }}</div>

              <class-assignment-modal
                :lessonAssignment="exam"
                :sectionType="2"
                :class_id="class_id"
                :platform_customer_id="customer_id"
              ></class-assignment-modal>
            </vs-collapse-item>
          </vs-collapse>
        </template>
      </vs-tab>

      <vs-tab label="Files">
        <uploaded-files :all_files="classFiles" />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import OverallContent from './OverallContent.vue'
import ClassAssignmentModal from './Components/ClassAssignmentModal.vue'
import uploadedFiles from './Components/uploadedFiles.vue'

export default {
  name: 'classCurriculumDetails',
  components: {
    OverallContent,
    ClassAssignmentModal,
    uploadedFiles
  },
  data () {
    return {
      customer_id: null,
      class_id: null,
      classHomework: null,
      classExam: null,
      classFiles: null/* ,
      homeworkSubjects: null,
      examSubjects: null */
    }
  },
  methods: {
    getContent (data) {
      console.log('here', data)
      this.customer_id = data.customer_id
      this.class_id = data.class_id
      //this.classHomework = data.classHomework
      // eslint-disable-next-line no-undef
      this.classHomework = _.groupBy(data.classHomework, subject => subject.subject.subject_name)
      //this.classExam = data.classExam
      // eslint-disable-next-line no-undef
      this.classExam = _.groupBy(data.classExam, subject => subject.subject.subject_name)
      this.classFiles = data.classFile
    }
  }
}
</script>
